import { LocalFileSystemID, FailureType } from '../shared/types';
import { createURI } from '../shared/utils/URI';
import { CommandID } from '../commands';
import { command$ } from '../observables/command';
import { error$ } from '../observables/error';
export default function (path, selected, connect) {
    return [
        {
            id: 'connect',
            label: 'Connect...',
            click: () => connect()
        },
        {
            id: 'connect-new-tab',
            label: 'Connect in New Tab...',
            click: () => {
                const u = new URL(window.location.origin);
                u.searchParams.append('connect', path);
                window.open(u.toString(), '_blank');
            },
            separator: true
        },
        {
            id: 'edit-connection',
            label: 'Edit...',
            click: () => command$.next({ id: CommandID.Edit, uri: createURI(LocalFileSystemID, path) })
        },
        {
            id: 'rename',
            label: 'Rename...',
            click: () => command$.next({ id: CommandID.Rename, uri: createURI(LocalFileSystemID, path) })
        },
        {
            id: CommandID.Duplicate,
            label: 'Duplicate',
            click: () => command$.next({ id: CommandID.Duplicate, uri: createURI(LocalFileSystemID, path) })
        },
        {
            id: 'delete',
            label: 'Delete',
            className: 'attention',
            click: () => {
                error$.next({
                    type: FailureType.ConfirmDeletion,
                    files: ((selected.length && selected.includes(path)) ? selected : [path]).map(path => createURI(LocalFileSystemID, path))
                });
            }
        }
    ];
}
